import React, { useState } from 'react';
import PropTypes from 'prop-types';
import bowser from 'yola-bowser';
import Toggle from '../toggle';
import IconButton from '../icon-button';
import Heading from '../heading';
import Box from '../box';
import InfoWithPopover from '../info-with-popover';

const isTouchDevice = bowser.mobile || bowser.tablet;

const ToggleSection = ({
  children = null,
  title,
  popoverProps = null,
  value = null,
  defaultValue = true,
  onReload = null,
  onChange = Function.prototype,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultValue);
  const [isVisible, setIsVisible] = useState(isTouchDevice);

  const handleChange = () => {
    if (value === null) {
      setIsCollapsed(!isCollapsed);
      onChange(!isCollapsed);
    } else {
      onChange(!value);
    }
  };

  const handlers = {
    onMouseEnter: () => setIsVisible(true),
    onMouseLeave: () => setIsVisible(false),
  };

  const collapsedContentVisible = value === null ? !isCollapsed : value;

  return (
    <div className="ws-ui-toggle-section" {...(!isTouchDevice && { ...handlers })}>
      <div className="ws-ui-toggle-section__header">
        <div className="ws-ui-toggle-section__header-content">
          <Heading type="heading-6" singleLine>
            {title}
          </Heading>
          {popoverProps && isVisible && (
            <InfoWithPopover {...popoverProps} {...(isTouchDevice && { mode: 'popover' })} />
          )}
        </div>
        <div className="ws-ui-toggle-section__header-actions">
          {onReload && <IconButton glyph="reset" onClick={onReload} size="small" />}
          <Toggle
            onChange={handleChange}
            size="small"
            checked={value !== null ? value : !isCollapsed}
          />
        </div>
      </div>
      {!!children && collapsedContentVisible && <Box marginTop="spacing-2-xs">{children}</Box>}
    </div>
  );
};

ToggleSection.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  popoverProps: PropTypes.shape({
    title: PropTypes.node,
    content: PropTypes.node,
    imgSrc: PropTypes.string,
  }),
  defaultValue: PropTypes.bool,
  value: PropTypes.bool,
  onReload: PropTypes.func,
  onChange: PropTypes.func,
};

export default ToggleSection;
